module.exports = new __parcel__URL__("screens.46830121.png").toString();